<template>
  <div class="textBoxArea">
    <div class="textAreaSection" v-for="(item , i ) in items" :key="i">
<!--      <textarea id="textarea_match" :placeholder="$t('matchMaking.description')" rows="5" class="ma-0 pa-0" v-model="inputText[i]">-->
<!--      </textarea>-->
      <v-textarea
          v-model="inputText[i]"
          :placeholder="$t('matchMaking.description')"
          :rules="requiredRulesTextArea"
          outlined
          height="190"
          class="ma-0 pa-0"
          style="margin: 0 auto"
      />
    </div>

    <v-btn class="confirmBtn" block color="#3CBE8B" elevation="0" id="confirm_btn" @click="changes" v-if="$vuetify.breakpoint.lgAndUp">
      {{$t('matchMaking.buttons.submit')}}
    </v-btn>
  </div>
</template>

<script>

export default {
  props: {
    items: Array,
    callChangeInOption: Boolean,
    initialAnswers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputText: [],
    }
  },
  mounted() {
    this.applyInitialAnswers()
  },
  methods: {
    applyInitialAnswers() {
      if (!this.initialAnswers?.length || !this.items?.length) {
        return
      }
      this.inputText = this.items.map((item) => {
        const answer = this.initialAnswers.find((entry) => entry.question_option_id === item.id)
        return answer?.answer_text || ''
      })
    },
    changes() {
      let checker = true;
      if (this.inputText.length > 0) {
        this.inputText.forEach((item) => {
          if (!item || item == "") {
            this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')});
            checker = false
          }
        })
        if (checker){
          this.$emit('answerHandler', this.inputText.map((item, i) => {
            if (item) {
              return {
                'question_option_id': this.items[i].id,
                'answer_text': item,
              }
            }
          }))
          console.log('emited')
        }
      }else{
        this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')});
      }
    },
  },
  watch: {
    initialAnswers: {
      handler() {
        this.applyInitialAnswers()
      },
      deep: true,
    },
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    }
  }
}
</script>

<style scoped>


.textAreaSection {


}

.textAreaSection textarea {
  width: 100%;
}
.textBoxArea{
  //width: 50%;
  margin: auto;
}
@media (min-width: 200px ) and (max-width: 600px) {
  .textBoxArea{
    width: 100% !important;
  }
}


</style>
